export default "__VITE_ASSET__Bb9P$qlG__"